export interface MediaDevice {
	/** Unique id of the device */
	deviceId: string
	/** Type of device */
	kind: MediaDeviceType
	/** Human friendly name of the device */
	label: string
	/** Id of device group that the device belongs to (e.g. a mic and speaker is paired in a group) */
	groupId: string
	/** Id of the hardware product/model */
	productId: string
	/** Raw label of the device */
	rawLabel: string
}

export enum MediaDeviceType {
	audioinput = 'audioinput',
	audiooutput = 'audiooutput',
	videoinput = 'videoinput'
}

export interface MediaDeviceSettingsItem {
	value: string
	label: string
	group?: string
	selected: boolean
}
